<script>
    import Search from 'lucide-svelte/icons/search';
    import { onMount } from 'svelte';

    export let q;
    export let actionUrl;
    export let propubUrlRoot = '/';
    export let searchType = 'school';
    export let schoolTypePlaceholder = 'Search for schools …';
    export let districtTypePlaceholder = 'Search for districts …';

    $: currentSearchType = searchType === 'district' ? 'district' : 'school';

    onMount(() => {
        actionUrl = `${window.location.origin}${propubUrlRoot}search`;
    });
</script>

<div class="search-container">
    <form method="get" action={actionUrl}>
        <div class="input-wrapper">
            <select name="type" bind:value={currentSearchType}>
                <option value="school" selected={currentSearchType !== 'district' ? true : null}>Schools</option>
                <option value="district" selected={currentSearchType === 'district' ? true : null}>Districts</option>
            </select>
            <input
                bind:value={q}
                name="q"
                type="text"
                inputmode="search"
                placeholder={currentSearchType !== 'district' ? schoolTypePlaceholder : districtTypePlaceholder}
            />
        </div>
        <button class="search-button">
            <Search />
        </button>
    </form>
</div>

<style lang="scss">
    .search-container {
        border-radius: 4px;
        background: #eeece7;

        &:focus-within {
            color: #fff;
            outline: 2px solid #005fcc;
        }

        @media only screen and (width < 48em) {
            width: 100%;
        }

        form {
            display: flex;
            align-items: stretch;
            border-bottom-right-radius: 4px;
            border-top-right-radius: 4px;
            color: var(--gray-50);
            font-size: var(--scale-1);
            line-height: 1.5;
        }

        select {
            height: 100%;
            border: none;
            border-radius: 4px;
            color: var(--gray-50);
            font-size: var(--scale-1);

            &:focus {
                outline: 0;
            }
        }

        input[type='text'] {
            height: auto;
            padding-right: 0;
            border: 0;
            border-radius: 0;
            background: #fff;
            color: var(--gray-50);
            line-height: normal;

            &:focus {
                background: #fff;
                color: var(--gray-97);
                outline: 0;
            }

            &::placeholder {
                color: var(--gray-50);
            }

            @media only screen and (width < 48em) {
                width: 100%;
            }
        }

        input:placeholder-shown {
            text-overflow: ellipsis;
        }

        .input-wrapper {
            display: flex;
            height: auto;
            flex: 1;
            align-items: stretch;
            padding: 0;
        }

        .search-button {
            height: auto;
            padding: 0.5em;
            background: #006997;
            border-bottom-right-radius: 4px;
            border-top-right-radius: 4px;
            line-height: var(--scale1);

            @media (prefers-color-scheme: dark) {
                color: #fff;
            }
        }
    }
</style>
